import apiClient from '../axios';

export default {
    getNotificacionesPorUsuario(id_usuario) {
        return apiClient.get(`/notificaciones/usuario/${id_usuario}`);
    },

    putdesactivar(id_notificacion) {
        return apiClient.put(`/notificaciones/${id_notificacion}`);
    },

    getbuscador(id_usuario) {
        return apiClient.get(`/detalle/usuario/${id_usuario}`);
    },
};